import Address from './zipCode.vue'

Address.install = function (Vue) {
    Vue.component('vue-address', Address)
}

export default Address
